import { render, staticRenderFns } from "./MModal.vue?vue&type=template&id=21a07fe0"
import script from "./MModal.vue?vue&type=script&lang=js"
export * from "./MModal.vue?vue&type=script&lang=js"
import style0 from "./MModal.vue?vue&type=style&index=0&id=21a07fe0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports